module.exports = __webpack_public_path__ + "img/Georgia_quad.19290253.jpg";